<template>
  <div v-if="visible" class="install-update-modal">
    <div class="mask">
      <div class="box">
        <div class="box-bg">
          <div class="title">发现新版本</div>
          <div class="version">V{{ versionInfo.lastVersion }}</div>
        </div>
        <!-- 非强制升级时显示关闭按钮 -->
        <div v-if="!versionInfo.forceUpgrade" class="close-btn" @click="handleClose" />
        <div class="box-title">发现新版本</div>
        <div class="box-desc">{{ versionInfo.upgradeMsg || '更新内容' }}</div>
        <div class="partition" />
        <div class="box-footer">
          <div class="btn-install" @click="handleInstall">立即安装</div>
          <div v-if="!versionInfo.forceUpgrade" class="btn-later" @click="handleClose">稍后安装</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isRunningInElectron } from '@/utils/electronUtils'

export default {
  name: 'InstallUpdateModal',
  data() {
    return {
      visible: false,
      versionInfo: {}
    }
  },
  methods: {
    // 展示弹窗
    show(versionInfo) {
      this.versionInfo = versionInfo || {}
      this.visible = true
    },
    // 用户点击立即安装
    handleInstall() {
      if (isRunningInElectron()) {
        window.electron.ipcRenderer.send('installUpdate')
      }
    },
    // 用户点击稍后安装或关闭
    handleClose() {
      this.visible = false
      this.versionInfo = {}
    }
  }
}
</script>

<style scoped lang="scss">
.install-update-modal {
  position: fixed;
  inset: 0;
  z-index: 9998;
}

.mask {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.box {
  position: relative;
  width: 410px;
  padding: 197px 28px 20px;
  background: #ffffff;
  border-radius: 24px;

  .box-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: -15px;
    width: 410px;
    height: 197px;
    background-image: url('../../assets/login/version-up-icon.png');
    background-size: 100% 100%;

    .title {
      font-weight: 400;
      font-size: 28px;
      color: #ffffff;
      margin: 50px 0 10px 20px;
    }

    .version {
      display: inline-block;
      font-size: 14px;
      color: #ffffff;
      height: 30px;
      line-height: 30px;
      padding: 0 12px;
      margin-left: 20px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 18px;
      border: 1px solid #ffffff;
    }
  }

  .close-btn {
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url('../../assets/login/version-close.png');
    background-size: 100% 100%;
    cursor: pointer;
  }

  .box-title {
    margin: 28px auto 14px;
    font-size: 26px;
    font-weight: 600;
    color: #1dc060;
    line-height: 37px;
    text-align: center;
  }

  .box-desc {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin-bottom: 14px;
    white-space: pre-line;
  }

  .partition {
    height: 1px;
    background: #e5e5e5;
    margin-bottom: 20px;
  }

  .box-footer {
    .btn-install {
      height: 54px;
      background: #1976ff;
      border-radius: 100px;
      font-size: 17px;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        background: #0565f3;
      }
    }

    .btn-later {
      height: 54px;
      line-height: 54px;
      text-align: center;
      font-size: 17px;
      color: #666666;
      cursor: pointer;
    }
  }
}
</style>
